"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroundwaterMohole = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const Resources_1 = require("../../../Resources");
const CardRenderer_1 = require("../../render/CardRenderer");
const Tags_1 = require("../../Tags");
const SpaceBonus_1 = require("../../../SpaceBonus");
const SelectSpace_1 = require("../../../inputs/SelectSpace");
const Units_1 = require("../../../Units");
const CardRenderItem_1 = require("../../render/CardRenderItem");
const TileType_1 = require("../../../TileType");
class GroundwaterMohole extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.GROUNDWATER_MOHOLE,
            tags: [Tags_1.Tags.BUILDING],
            productionBox: Units_1.Units.of({ steel: 1 }),
            metadata: {
                cardNumber: 'Y24',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.oceans(1).secondaryTag(CardRenderItem_1.AltSecondaryTag.STEEL_RESOURCE).asterix().br;
                    b.production((pb) => pb.steel(1));
                    b.heat(3);
                }),
                description: 'Place an ocean tile on an area where you gain steel as a placement bonus. Increase your steel production 1 step. Gain 3 heat.',
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.STEEL);
        player.addResource(Resources_1.Resources.HEAT, 3);
        const spaces = player.game.board.getAvailableSpacesOnLand(player)
            .concat(player.game.board.getAvailableSpacesForOcean(player))
            .filter((space) => space.bonus.includes(SpaceBonus_1.SpaceBonus.STEEL));
        return new SelectSpace_1.SelectSpace('Select a space with a steel placement bonus to place an ocean', spaces, TileType_1.TileType.OCEAN, (foundSpace) => {
            player.game.addOceanTile(player, foundSpace.id, foundSpace.spaceType);
            return undefined;
        });
    }
}
exports.GroundwaterMohole = GroundwaterMohole;
//# sourceMappingURL=GroundwaterMohole.js.map